import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import CircularProgress from "@material-ui/core/CircularProgress";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { IStateList, ListComponent } from "components/Abstract/List";
import EmptyList from "components/Shared/EmptyList";
import { WithStyles } from "decorators/withStyles";
import { IPaginationParams } from "interfaces/pagination";
import { userRoles } from "interfaces/user";
import { IUserToken } from "interfaces/userToken";
import { IVenture } from "interfaces/venture";
import React from "react";
import { combineLatest } from "rxjs";
import RxOp from "rxjs-operators";
import authService from "services/auth";
import entityService from "services/entity";
import selectedVentureService from "services/profile";
import ventureService from "services/venture";

interface IState extends IStateList<IVenture> {
  current?: IVenture;
  formOpened?: boolean;
  loading: boolean;
  user: IUserToken;
}
interface IProps {
  history: any;
  classes: any;
}

@WithStyles((theme) => ({
  item: {
    transition: "0.3s",
    "&:hover": {
      transform: "scale(1.05)",
    },
    "&:hover h6": {
      opacity: "1 !important",
    },
  },
  media: {
    height: 0,
    paddingTop: "56.25%", // 16:9
    backgroundSize: "contain",
  },
  card: {
    height: "100%",
  },
}))
export default class Home extends ListComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props, "createdDate", "asc", 9007199254740991);
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = (params: Partial<IPaginationParams> = {}) => {
    this.setState({ loading: true, error: null });
    const { history } = this.props;
    combineLatest([
      selectedVentureService.getSelectedVenture(),
      authService.getUser(),
    ])
      .pipe(RxOp.logError(), RxOp.bindComponent(this))
      .subscribe(([selection, user]) => {
        this.setState({ user });
        if (selection && selection.id) {
          let path = "/documentation/dashboard";
          if (!user) return history.push(path);
          if (user.roles.includes(userRoles.visitor)) {
            return entityService
              .fetchEntitiesGraph(selection.id)
              .pipe(RxOp.logError(), RxOp.bindComponent(this))
              .subscribe((graph) => {
                if (graph && graph.data) {
                  path = `/files/venture/${selection.id}/entity/1`;
                  // console.log('navigating to', path);
                  return history.push(path);
                }
              });
          } else {
            // console.log('navigating to', path);
            return history.push(path);
          }
        }
      });

    ventureService
      .list(this.mergeParams(params))
      .pipe(RxOp.logError(), RxOp.bindComponent(this))
      .subscribe(
        (items) => {
          if (!items.total) {
            return history.push("/settings/ventures");
          }
          this.setPaginatedData(items);
        },
        (error) => this.setError(error)
      );
  };

  setVentureAndRedirect = (venture: IVenture) => () => {
    const { id, name } = venture;
    selectedVentureService
      .setProfile({ id, name })
      .pipe(RxOp.logError(), RxOp.bindComponent(this))
      .subscribe(() => {
        this.props.history.push("/documentation/dashboard");
      });
  };

  render() {
    const { items, loading } = this.state;
    const { classes } = this.props;

    return (
      <Container>
        <Card>
          <CardContent>
            <Grid container justify="center" spacing={3}>
              <Grid item xs={12}>
                <Typography
                  variant="h6"
                  component="p"
                  align="center"
                  color="primary"
                >
                  Selecionar empreendimentos
                </Typography>
                <Typography
                  variant="body1"
                  component="p"
                  align="center"
                  gutterBottom
                >
                  Seja bem-vindo ao perfil gerencial. Escolha um empreendimento
                  abaixo para prosseguir.
                </Typography>
              </Grid>
              {loading && (
                <Grid item>
                  <CircularProgress />
                </Grid>
              )}
              {!loading &&
                items
                  .sort((a, b) => a.id - b.id)
                  .map((venture) => (
                    <Grid
                      item
                      key={venture.id}
                      className={classes.item}
                      xs={12}
                      sm={6}
                      md={4}
                      xl={2}
                    >
                      <Card style={{ height: "100%" }}>
                        <CardActionArea
                          style={{ height: "100%" }}
                          onClick={this.setVentureAndRedirect(venture)}
                        >
                          <CardMedia
                            className={classes.media}
                            image={venture.logo}
                            title={venture.name}
                          />
                          <CardContent>
                            <Typography
                              align="center"
                              color="primary"
                              variant="subtitle1"
                              style={{ opacity: 0.6 }}
                            >
                              {venture.name}
                            </Typography>
                          </CardContent>
                        </CardActionArea>
                      </Card>
                    </Grid>
                  ))}
              {!loading && !items.length && (
                <Grid item>
                  <EmptyList message="Nenhum empreendimento cadastrado" />
                </Grid>
              )}
            </Grid>
          </CardContent>
        </Card>
      </Container>
    );
  }
}
